module.exports = __webpack_public_path__ + "static/media/contact-alt.ee4bc803.svg";